var EHDI = EHDI || Object.create(null);

EHDI.GameStateEnum = {
  GAMEINITIALIZING: 0,
  GAMESHUFFLE: 1,
  GAMESTARTED: 2,
  GAMEPAUSED: 3,
  GAMERESUMED: 4,
  GAMEOVER: 5,
};

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.GameScene = function () {
    EHDI.Scene.call(this);
};

EHDI.scene.GameScene.prototype = Object.create(EHDI.Scene.prototype);

EHDI.scene.GameScene.prototype.screenWillAppear = function () {
  this.init();
};

EHDI.scene.GameScene.prototype.popUpWillAppear = function() {
  EHDI.GAME.soundManager.pauseAllSFX();
  EHDI.GAME.soundManager.pauseBGM();
};

EHDI.scene.GameScene.prototype.popUpDidDisappear = function() {
  EHDI.GAME.soundManager.resumeAllSFX();
  EHDI.GAME.soundManager.resumeBGM();
};

EHDI.scene.GameScene.prototype.screenDidAppear = function () {
  this.shuffleGrid();
  var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
  if(cache.isFirstTimePlay)
  {    
      cache.isFirstTimePlay = false;   
      EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
      EHDI.GAME.pauseButton.isPaused = true;
      EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
      EHDI.GAME.soundManager.pauseAllSFX();
      this._handler_pauseGame();
  }
}

EHDI.scene.GameScene.prototype.init = function () {
   EHDI.GAME.gameScene = this;
    this.initProps();
    this.initGraphics();
    this.initListeners();
};

EHDI.scene.GameScene.prototype.destroy = function () {
  this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);

  this.killListeners();
  this.killGraphics();
  this.killProps();

  // EHDI.GetGlobalPool().gameScenePool.return(this);
}

EHDI.scene.GameScene.prototype.restart = function() {
  this.destroy();
  this.init();
}
EHDI.scene.GameScene.prototype.replay = function() {
    this.destroy();
    this.init();
}

EHDI.scene.GameScene.prototype.initProps = function () {
  this._gameState;
  this._gameWidth = 1024;
  this._gameHeight = 600;

  this._gameState = EHDI.GameStateEnum.GAMEINITIALIZING;
  this._prevState;

  this._deltaTotal = 0;
  this._clearCount = 1;
  this._deltaLimit = 25;

  this._ballCount = 0;
  this._collectibleCount = Math.floor(Math.random() * 3);

  this.interactive = true;
  this._touchPoint = new EHDI.aka.Point(0,0);
  this._onTouch = false;
};

EHDI.scene.GameScene.prototype.killProps = function () {
  this._gameState = null;
  this._gameWidth = null;
  this._gameHeight = null;

  this._gameState = null;
  this._prevState = null;

  this._deltaTotal = null;
  this._deltaLimit = null;

  this._ballCount = null;
  this._collectibleCount = null;

  this.interactive = null;
  this._touchPoint = null;
  this._onTouch = null;
}

EHDI.scene.GameScene.prototype.initGraphics = function () {
  this._background;
  this._mid;
  this._grid;
  this._top;
  this._slide;
  this._collectibleIndicator;

  this._gameContainer;
  this._container2D;
  this._ball;

  this._hudContainer;
  this._powerContainer;
  this._hudPauseButton;
  this._scoreContainer;
  this._textDiscCount;
  this._collectible;

  this._scoreAnimation;

  // this._backgroundGlow;

  if (this._background == null) {
    this._background = new EHDI.aka.Sprite(EHDI.Assets.images["bg_ingame"]);

    this.addChild(this._background);
  }

  // if (this._backgroundGlow == null) {
  //   this._backgroundGlow = new EHDI.aka.Sprite(EHDI.Assets.images["bg_glow1"]);
  //
  //   this.addChild(this._backgroundGlow);
  // }

  if (this._mid == null) {
    this._mid = new EHDI.aka.Sprite(EHDI.Assets.images["mid"]);
    this._mid.anchor.set(0.5,0);
    this._mid.x = this._gameWidth * 0.5;

    this.addChild(this._mid);
  }

  if (this._grid == null) {
    this._grid = new EHDI.game.Grid();
    this._grid.init();
    this._grid.x = this._gameWidth * 0.5;
    this._grid.y = this._gameHeight * 0.38;

    this.addChild(this._grid);
  }

  if (this._top == null) {
    this._top = new EHDI.aka.Sprite(EHDI.Assets.images["top"]);
    this._top.anchor.set(0.5,0);
    this._top.x = this._gameWidth * 0.5;

    this.addChild(this._top);
  }

  if (this._collectibleIndicator == null) {
    this._collectibleIndicator = new EHDI.game.CollectibleIndicator();
    this._collectibleIndicator.init();

    this._collectibleIndicator.x = 900;
    this._collectibleIndicator.y = 250;

    this.addChild(this._collectibleIndicator);
  }

  if (this._slide == null) {
    this._slide = new EHDI.aka.Sprite(EHDI.Assets.images["slide"]);
    this._slide.anchor.set(0.5,1);
    this._slide.x = this._gameWidth * 0.5;
    this._slide.y = this._gameHeight;

    this.addChild(this._slide);
  }

  if (this._gameContainer == null) {
    this._gameContainer = new EHDI.aka.Container();

    this.addChild(this._gameContainer);
  }

  if (this._container2D == null) {
    this._container2D = new PIXI.projection.Container2d();
    this._container2D.position.set(this._gameWidth  * 0.5, this._gameHeight);
    this._gameContainer.addChild(this._container2D);

    this._container2D.proj.setAxisY(new EHDI.aka.Point(0, 450), -1);
  }

  if (this._collectible == null) {
    this._collectible = new EHDI.game.Collectible();
    this._collectible.init();

    this._collectible.y = -370;

    this._container2D.addChild(this._collectible);
  }

  if (this._ball == null) {
    this._ball = new EHDI.game.Ball();
    this._ball.init();
  }

  if (this._scoreAnimation == null) {
    this._scoreAnimation = new EHDI.game.ScoreContainer();
    this._scoreAnimation.init();

    this.addChild(this._scoreAnimation);
  }

  if (this._hudContainer == null) {
    this._hudContainer = new EHDI.aka.Container();

    this.addChild(this._hudContainer);
  }

  if (this._powerContainer == null) {
    this._powerContainer = new EHDI.game.Power();
    this._powerContainer.init();
    this._powerContainer.x = 52;
    this._powerContainer.y = 420;

    this._hudContainer.addChild(this._powerContainer);
  }

  if (this._textDiscCount == null) {
    this._textDiscCount = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_CONT_DISC_COUNT"));

    this._textDiscCount.x = 808 - 10;
    this._textDiscCount.y = 420;

    this.addChild(this._textDiscCount);
  }

  if (this._addDiscAnimation == null) {
    this._addDiscAnimation = new EHDI.game.AddDiscContainer();
    this._addDiscAnimation.init();

    this._addDiscAnimation.x = this._textDiscCount.x + 20;
    this._addDiscAnimation.y = this._textDiscCount.y + 14;

    this.addChild(this._addDiscAnimation);
  }

  if (this._scoreContainer == null) {
    this._scoreContainer = new EHDI.components.ScoreManager(this._hudContainer);
    this._scoreContainer.setXY(10,10);
  }

  if (this._hudPauseButton == null) {
    this._hudPauseButton = new EHDI.components.pauseButton();

    this._hudContainer.addChild(this._hudPauseButton);
  }

   this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
      this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.95, EHDI.GAME.sceneManager.getStageHeight() * 0.075);
      this.closeBtn.setOnClickFunction(function(){
        callFlexFunction()
      });
      this._hudContainer.addChild(this.closeBtn);
};

EHDI.scene.GameScene.prototype.killGraphics = function () {
  if (this._hudPauseButton != null) {
    this._hudContainer.removeChild(this._hudPauseButton);

    this._hudPauseButton.destroy();
    this._hudPauseButton = null;
  }

  if(this.closeBtn != null)
        {
            this._hudContainer.removeChild(this.closeBtn);
            this.closeBtn.destroy();
            this.closeBtn = null;
        }
      

  if (this._scoreContainer != null) {
    this._scoreContainer.dispose();
    this._scoreContainer = null;
  }

  if (this._addDiscAnimation != null) {
    this.removeChild(this._addDiscAnimation);

    this._addDiscAnimation.destroy();
    this._addDiscAnimation = null;
  }

  if (this._textDiscCount != null) {
    this.removeChild(this._textDiscCount);

    this._textDiscCount = null;
  }

  if (this._powerContainer != null) {
    this._hudContainer.removeChild(this._powerContainer);
    this._powerContainer.destroy();
    this._powerContainer = null;
  }

  if (this._hudContainer != null) {
    this.removeChild(this._hudContainer);
    this._hudContainer = null;
  }

  if (this._scoreAnimation != null) {
    this.removeChild(this._scoreAnimation);
    this._scoreAnimation = null;
  }

  if (this._ball != null) {
    this._container2D.removeChild(this._ball);

    this._ball = null;
  }

  if (this._collectible != null) {
    this._container2D.removeChild(this._collectible);

    this._collectible = null;
  }

  if (this._container2D != null) {
    this._gameContainer.removeChild(this._container2D);
    this._container2D = null;
  }

  if (this._gameContainer != null) {
    this.removeChild(this._gameContainer);
    this._gameContainer = null;
  }

  if (this._slide != null) {
    this.removeChild(this._slide);
    this._slide = null;
  }

  if (this._collectibleIndicator != null) {
    this.removeChild(this._collectibleIndicator);
    this._collectibleIndicator = null;
  }

  if (this._top != null) {
    this.removeChild(this._top);
    this._top = null;
  }

  if (this._grid != null) {
    this.removeChild(this._grid);
    this._grid = null;
  }

  if (this._mid != null) {
    this.removeChild(this._mid);
    this._mid = null;
  }

  // if (this._backgroundGlow != null) {
  //   this.removeChild(this._backgroundGlow);
  //   this._backgroundGlow = null;
  // }

  if (this._background != null) {
    this.removeChild(this._background);
    this._background = null;
  }
};

EHDI.scene.GameScene.prototype.initListeners = function () {
    if (this.onBallActivatedWithBind == null)
      this.onBallActivatedWithBind = this._handler_onBallActivated.bind(this);

    if (this.onBallSwitchWithBind == null)
      this.onBallSwitchWithBind = this._handler_onBallSwitch.bind(this);

    if (this.onBallStoppedWithBind == null)
      this.onBallStoppedWithBind = this._handler_onBallStopped.bind(this);

      if (this.onBallBackWithBind == null)
        this.onBallBackWithBind = this._handler_onBallBack.bind(this);

    if (this.onBallAnimateoutWithBind == null)
      this.onBallAnimateoutWithBind = this._handler_onBallAnimateout.bind(this);

    if (this.updateWithBind == null)
      this.updateWithBind = this.update.bind(this);

    if (this.onPauseWithBind == null)
      this.onPauseWithBind = this._handler_pauseGame.bind(this);

    if (this.onResumeWithBind == null)
        this.onResumeWithBind = this._handler_resumeGame.bind(this);

    if (this.onPointerDownWithBind == null)
      this.onPointerDownWithBind = this._handler_onPointerDown.bind(this);

    if (this.onPointerUpWithBind == null)
      this.onPointerUpWithBind = this._handler_onPointerUp.bind(this);

    if (this.onPointerMoveWithBind == null)
      this.onPointerMoveWithBind = this._handler_onPointerMove.bind(this);

    if (this.onPointerOusideWithBind == null)
      this.onPointerOusideWithBind = this._handler_onPointerOutside.bind(this);

    if (this.onShuffleFinishedWithBind == null)
      this.onShuffleFinishedWithBind = this._handlerOnShuffleFinished.bind(this);
    
    if (this.onShuffleWithBind == null)
      this.onShuffleWithBind = this._handlerOnShuffle.bind(this);

    EHDI.GAME.updateManager.addFrameListener(this.updateWithBind);

    this._hudPauseButton.on('PAUSE_GAME', this.onPauseWithBind);
    this._hudPauseButton.on('RESUME_GAME', this.onResumeWithBind);

    this._ball.on("BALL_STOPPED", this.onBallStoppedWithBind);
    this._ball.on("BALL_BACK_AT_STARTING", this.onBallBackWithBind);
    this._ball.on("BALL_ANIMATEOUT", this.onBallAnimateoutWithBind);
    this._ball.on('BALL_ACTIVATED', this.onBallActivatedWithBind);
    this._ball.on('SWITCH_BALL', this.onBallSwitchWithBind);

    this.on('pointerdown', this.onPointerDownWithBind);
    this.on('pointerup', this.onPointerUpWithBind);
    this.on('pointermove', this.onPointerMoveWithBind);
    this.on('pointerupoutside', this.onPointerOusideWithBind);
    this.on('pointerout', this.onPointerOusideWithBind);

    this._grid.on('SHUFFLE_FINISHED', this.onShuffleFinishedWithBind);
    this._grid.on('SHUFFLE_DURING', this.onShuffleWithBind);
};

EHDI.scene.GameScene.prototype.killListeners = function () {

    EHDI.GAME.updateManager.removeFrameListener(this.updateWithBind);

    this._hudPauseButton.removeListener('PAUSE_GAME', this.onPauseWithBind);
    this._hudPauseButton.removeListener('RESUME_GAME', this.onResumeWithBind);

    this._ball.removeListener("BALL_STOPPED", this.onBallStoppedWithBind);
    this._ball.removeListener("BALL_BACK_AT_STARTING", this.onBallBackWithBind);
    this._ball.removeListener("BALL_ANIMATEOUT", this.onBallAnimateoutWithBind);
    this._ball.removeListener('BALL_ACTIVATED', this.onBallActivatedWithBind);
    this._ball.removeListener('SWITCH_BALL', this.onBallSwitchWithBind);

    this.removeListener('pointerdown', this.onPointerDownWithBind);
    this.removeListener('pointerup', this.onPointerUpWithBind);
    this.removeListener('pointermove', this.onPointerMoveWithBind);
    this.removeListener('pointerupoutside', this.onPointerOusideWithBind);
    this.removeListener('pointerout', this.onPointerOusideWithBind);

    this._grid.removeListener('SHUFFLE_FINISHED', this.onShuffleFinishedWithBind);

  if (this.onBallActivatedWithBind != null)
    this.onBallActivatedWithBind = this._handler_onBallActivated.bind(this);

  if (this.onBallSwitchWithBind != null)
    this.onBallSwitchWithBind = this._handler_onBallSwitch.bind(this);

  if (this.onBallStoppedWithBind != null)
    this.onBallStoppedWithBind = this._handler_onBallStopped.bind(this);

    if (this.onBallBackWithBind != null)
      this.onBallBackWithBind = this._handler_onBallBack.bind(this);

  if (this.onBallAnimateoutWithBind != null)
    this.onBallAnimateoutWithBind = null;

  if (this.updateWithBind != null)
    this.updateWithBind = null;

  if (this.onPauseWithBind != null)
    this.onPauseWithBind = null;

  if (this.onResumeWithBind != null)
      this.onResumeWithBind = null;

  if (this.onPointerDownWithBind != null)
    this.onPointerDownWithBind = null;

  if (this.onPointerUpWithBind != null)
    this.onPointerUpWithBind = null;

  if (this.onPointerMoveWithBind != null)
    this.onPointerMoveWithBind = null;

  if (this.onPointerOusideWithBind != null)
    this.onPointerOusideWithBind = null;

  if (this.onShuffleFinishedWithBind != null)
    this.onShuffleFinishedWithBind = null;
};

EHDI.scene.GameScene.prototype.startGame = function () {
  this.gameStateManager(EHDI.GameStateEnum.GAMESTARTED);
};

EHDI.scene.GameScene.prototype.shuffleGrid = function (e) {
  this.gameStateManager(EHDI.GameStateEnum.GAMESHUFFLE);
    
  this._grid.shuffle(e);
};

EHDI.scene.GameScene.prototype.gameStateManager = function (newState) {
  if (this._gameState != newState) {
    this._gameState = newState;
  }
};

EHDI.scene.GameScene.prototype._handlerOnShuffleFinished = function (e) {
  this.startGame();
  this.updateBall();
}

EHDI.scene.GameScene.prototype._handlerOnShuffle = function () {
      console.log("clear");
      this._scoreContainer.addScore(10 * this._clearCount);
}

EHDI.scene.GameScene.prototype._handler_onBallActivated = function (e) {
}

EHDI.scene.GameScene.prototype._handler_onBallSwitch = function (e) {
  // this.swapChildren(this._gameContainer, this._slide);
}

EHDI.scene.GameScene.prototype._handler_onBallAnimateout = function (e) {
  var score = 0;
  var multiplier = 1;
  var adder = 0;
  var additionalBall = 0;

  if (this._collectible.isCollected() && this._collectibleIndicator.isActive()) {
    if (this._collectibleCount == 0) {
      multiplier *= 2;
    }else if (this._collectibleCount == 1) {
      additionalBall++;
    } else if (this._collectibleCount == 2) {
      adder = 30;
    }

    this._collectibleIndicator.explode();
  }

  if (e.tileCount == 0 || e.tileCount == 7)
    score = 10;
  else if (e.tileCount == 6 || e.tileCount == 5)
    score = 20;
  else if (e.tileCount == 3 || e.tileCount == 2)
    score = 30;
  else if (e.tileCount == 1 || e.tileCount == 8)
    score = 40;
  else
    score = 50

  if (this._grid.checkTileCount(e.tileCount)) {
    multiplier *= 2;
    this._grid.closeTileGrid(e.tileCount);
  }

  if (this._grid.checkPatternCount() <= 0) {
    additionalBall++;
  }

  if (additionalBall > 0) {
    this._ballCount -= additionalBall;

    this.updateBallText();
    this._addDiscAnimation.spawn(additionalBall);
  }

  score = score * multiplier + adder;

  var pos = this._grid.getGridtilePos(e.tileCount);

  this._scoreAnimation.x = pos.x + this._grid.x;
  this._scoreAnimation.y = pos.y + this._grid.y;

  this._scoreAnimation.spawn(score);

  if (e.addScore)
    this._scoreContainer.addScore(score);
}

EHDI.scene.GameScene.prototype._handler_onBallBack = function (e) {
  this._collectibleIndicator.remove();
  this._powerContainer.reset();
}

EHDI.scene.GameScene.prototype._handler_onBallStopped = function (e) {
  if (this._ballCount < 10) {
    this._powerContainer.reset();
    if (this._grid.checkPatternCount() > 0) {
      this.updateBall();
    } else {
      this._clearCount++;
      this.shuffleGrid(true);
      if(EHDI.GAME.constants.gameLevelComplete) {
        EHDI.GAME.constants.gameLevelComplete(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
      }
    }

    // this.swapChildren(this._slide, this._gameContainer);
  } else {
    this.showPostGamePopup();
  }

}

EHDI.scene.GameScene.prototype.getStar = function () {
  var score = this._scoreContainer.getScore();

  if (score == 0)
    return 0;
  else if (score <= 300)
    return 1;
  else if (score <= 800)
    return 2;
  else
    return 3
}

EHDI.scene.GameScene.prototype.gameUpdate = function (delta) {
  if (this._gameState  != EHDI.GameStateEnum.GAMEPAUSED) {
    dragonBones.WorldClock.clock.advanceTime(delta * 0.001);

    if (this._gameState  == EHDI.GameStateEnum.GAMESTARTED) {
      // this.updateGlow();
      this._ball.update(delta);
      this.updateForDepthSwap();
      this.updateForCollision();
      this._collectible.update(delta);
      this._collectibleIndicator.update(delta);
    } else if (this._gameState  == EHDI.GameStateEnum.GAMESHUFFLE) {
      // this.updateGlow();
      this._grid.update(delta);
    }
  }
};

EHDI.scene.GameScene.prototype.updateGlow = function() {
  // if (this._glowAlphaOut) {
  //   // this._backgroundGlow.alpha -= 0.005;
  //
  //   if (this._backgroundGlow.alpha <= 0.5) {
  //     this._backgroundGlow.alpha = 0.5;
  //     this._glowAlphaOut = false;
  //   }
  // } else {
  //   this._backgroundGlow.alpha += 0.005;
  //
  //   if (this._backgroundGlow.alpha >= 1) {
  //     this._backgroundGlow.alpha = 1;
  //     this._glowAlphaOut = true;
  //   }
  // }
}

EHDI.scene.GameScene.prototype.updateForCollision = function () {
  if (this._collectible.isActive() && Math.abs(this._ball.getX() - this._collectible.getCollectibleX()) <= 74 && Math.abs(this._ball.y - this._collectible.y) <= 74) {
    this._collectible.explode();
    this._collectibleIndicator.spawn(this._collectible.getCollectibleCount());

    EHDI.GAME.soundManager.playSFX("pickup");
  }
}

EHDI.scene.GameScene.prototype.spawnCollectible = function() {
  this._collectibleCount++;
  if (this._collectibleCount >= 3)
    this._collectibleCount = 0;

  this._collectible.spawn(240 - Math.random() * 480, this._collectibleCount);
}

EHDI.scene.GameScene.prototype.updateForDepthSwap = function () {
  if (this._ball.y < this._collectible.y && this._container2D.getChildIndex(this._ball) >  this._container2D.getChildIndex(this._collectible)) {
    this._container2D.swapChildren(this._ball, this._collectible);
  } else if (this._ball.y > this._collectible.y && this._container2D.getChildIndex(this._ball) <  this._container2D.getChildIndex(this._collectible)) {
    this._container2D.swapChildren(this._ball, this._collectible);
  }
}

EHDI.scene.GameScene.prototype.updateBallText = function() {
  if (this._ballCount <= 0)
    this._textDiscCount.x = 808 - 10;
  else
    this._textDiscCount.x = 808;

  this._textDiscCount.text = (10 - this._ballCount).toString();
}

EHDI.scene.GameScene.prototype.updateBall = function() {
  this._ball.reset();

  this._container2D.addChild(this._ball);
  this._ball.activate();
  this._ballCount++;
  this.updateBallText();

  this.manageSpawning();
}

EHDI.scene.GameScene.prototype.manageSpawning = function () {
  if (!this._collectible.isActive()) {
    this.spawnCollectible();
  }
}

EHDI.scene.GameScene.prototype.showPostGamePopup = function () {
  if (this._gameState != EHDI.GameStateEnum.GAMEOVER) {
    this.gameStateManager(EHDI.GameStateEnum.GAMEOVER);

    this._hudPauseButton.endGame();

    /*
    EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp
      (this.getStar(), this._scoreContainer.getScore()),
      {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(),
      EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    */

   var score = this._scoreContainer.getScore();

   var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
   if(score > cache.highScore) {
       EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
       cache.highScore = score;
   }

   if(EHDI.GAME.constants.gameEndFunction) {
       EHDI.GAME.soundManager.autoResumeToggle(true);
       EHDI.GAME.constants.gameEndFunction(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
   } else {
       var star = 0;
       if(score > 0 && score < 750) {
           star = 1;
       } else if (score >= 750 && score < 1500) {
           star = 2;
       } else if (score >= 1500) {
           star = 3;
       }

       EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
       EHDI.GAME.soundManager.autoResumeToggle(true);
       EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
   }
  }
};

EHDI.scene.GameScene.prototype.update = function (delta) {
  this._deltaTotal += delta * 25;
  if (this._deltaTotal >= this._deltaLimit) {
    this._deltaMultiplier = Math.floor(this._deltaTotal / this._deltaLimit);

    for (var i = 0; i < this._deltaMultiplier; i++) {
      this.gameUpdate(this._deltaLimit);
    }

    this._deltaTotal -= (this._deltaMultiplier * this._deltaLimit);
  }
};

EHDI.scene.GameScene.prototype._handler_pauseGame = function (e) {
  this._prevState = this._gameState;

  if (this._ball.getState() == EHDI.game.BallState.READY)
    this._ball.set();

  if (this._onTouch)
    this._onTouch = false;

  this._ball.pause();


  this.gameStateManager(EHDI.GameStateEnum.GAMEPAUSED);
};

EHDI.scene.GameScene.prototype._handler_resumeGame = function (e) {
  this.gameStateManager(this._prevState);
  this._ball.resume();
};

EHDI.scene.GameScene.prototype._handler_onPointerDown = function (e) {
  // if (e.target == this._ball && this._ball.getState() == EHDI.game.BallState.IDLE) {
  this._touchPoint = this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y));

  if (this._touchPoint.y - 20 <= e.data.global.y && this._ball.getState() == EHDI.game.BallState.IDLE) {
    this._ball.setX(Math.min(Math.max(this._container2D.toLocal(e.data.global).x, -240), 240));
    this._touchPoint = this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y));

    if (this._touchPoint.y < e.data.global.y)
      this._touchPoint.y = e.data.global.y;

    this._onTouch = true;
    this._ball.ready();
  }
};

EHDI.scene.GameScene.prototype._handler_onPointerUp = function (e) {
  if (this._onTouch) {
    this._onTouch = false;

    this._touchPoint = this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y));

    var angle = EHDI.util.Trigo.getUnitCircleAngle(new EHDI.aka.Point(this._ball.getX(), this._ball.y), this._container2D.toLocal(e.data.global));

    var hypotenuse = EHDI.util.Trigo.getHypotenuseUsingOppositeAndAdjacent
    (this._touchPoint.x - e.data.global.x, this._touchPoint.y - e.data.global.y);

    if (angle < 180) {
        this._ball.set();
    }

    if (hypotenuse >= 30 && angle > 200 && angle < 340) {

      hypotenuse = Math.max(Math.min(hypotenuse, 200), 60);

      this._ball.shoot(EHDI.util.Trigo.convertDegreeToRadian(angle), hypotenuse/200);
      this._powerContainer.set(hypotenuse/200);
    } else {
      this._ball.set();
    }

  }


  // if (this._ball.getState() == EHDI.game.BallState.SET ||
  // this._ball.getState() == EHDI.game.BallState.SET_AIMATION) {
  //   console.log("a");
  // this._ball.shoot(this._container2D.toLocal(e.data.global), 1);
  // } else {
  //   console.log("b");
  //   this._ball.reset();
  // }
};

EHDI.scene.GameScene.prototype._handler_onPointerMove = function (e) {
  if (this._onTouch) {
    // var angle = EHDI.util.Trigo.getUnitCircleAngle(this._touchPoint, e.data.global);

    // if (angle <= 200 || angle >= 340) {
    if (this._touchPoint.y - 20 <= e.data.global.y) {
      var global =  e.data.global;
      global.y = this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y - 60)).y;

      this._ball.setX(Math.min(Math.max(this._container2D.toLocal(global).x, -260), 260));
      this._touchPoint = this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y));

      if (this._touchPoint.y <= e.data.global.y)
        this._touchPoint.y = e.data.global.y;
    }

    // console.log(this._container2D.toLocal(e.data.global).x, this._container2D.toGlobal(new EHDI.aka.Point(this._ball.getX(), this._ball.y)).x);
    // }
  }
  // if ((e.data.global.y > 550) && this._ball.getState() == EHDI.game.BallState.SET || this._ball.getState() == EHDI.game.BallState.SET_ANIMATION) {
  //   var pos = this._container2D.toLocal(e.data.global);
  //
  //   this._ball.setX(Math.min(Math.max(pos.x, -240), 240));
  // }
}

EHDI.scene.GameScene.prototype._handler_onPointerOutside = function (e) {
  if (this._onTouch)
    this._onTouch = false;

  if (this._ball.getState() == EHDI.game.BallState.READY)
    this._ball.set();
  // this._ball.reset();
}
